(function (module) {
  'use strict';
  module
    .controller('clientSettingController', ['$scope', 'progressBar', 'clientSelectService', 'agencySelectService',
      'clientSettings', 'toastFactory', 'ngDialog', '$q', '$mdpTimePicker',
      function ($scope, progressBar, clientSelectService, agencySelectService, clientSettings, toastFactory,
        ngDialog, $q, $mdpTimePicker) {
        const progress = progressBar.getProgressBar();
        $scope.timeZones = {};
        $scope.agency = {};
        $scope.startBusinessHours = {};
        $scope.endBusinessHours = {};        

        // List of Days
        $scope.dayList = [{
          id: 1,
          name: 'Sunday',
        }, {
          id: 2,
          name: 'Monday',
        }, {
          id: 3,
          name: 'Tuesday',
        }, {
          id: 4,
          name: 'Wednesday',
        }, {
          id: 5,
          name: 'Thursday',
        }, {
          id: 6,
          name: 'Friday',
        }, {
          id: 7,
          name: 'Saturday',
        },];                

        // Validate that filtered organization id is defined
        function validateAgencyAndClientSelection() {
          const agency = agencySelectService.getSelectedAgency();
          const client = clientSelectService.getSelectedClient();
          return {
            agencyValid: agency.id != null && Number.isInteger(agency.id),
            clientValid: client.id != null && Number.isInteger(client.id),
          };
        }

        function getOrganizationById() {                    
          const valid = validateAgencyAndClientSelection();
          if (valid.agencyValid && valid.clientValid) {
            progress.start();
            const promiseTimeZone = clientSettings.getWindowsTimeZones();
            const promiseClientSettings = clientSettings.getOrganizationById(clientSelectService.getSelectedClient()
              .id);
            $q.all([promiseTimeZone, promiseClientSettings]).then(function (response) {
                $scope.timeZones = response[0].data;                
                $scope.agency = response[1].data;
                console.log($scope.agency);

                if ($scope.agency.TravelAgencyStartRegularHours) {
                  const startHourDate = $scope.agency.TravelAgencyStartRegularHours.split(':');
                  const startHour = startHourDate[0];
                  const startMin = startHourDate[1];
                  $scope.startBusinessHours = new Date(0, 0, 0, startHour, startMin);
                } else {
                  $scope.startBusinessHours = new Date(0, 0, 0, 0, 0);                    
                }

                if ($scope.agency.TravelAgencyEndRegularHours) {
                  const endHourDate = $scope.agency.TravelAgencyEndRegularHours.split(':');                
                  const endHour = endHourDate[0];
                  const endMin = endHourDate[1];                                
                  $scope.endBusinessHours = new Date(0, 0, 0, endHour, endMin);
                } else {
                  $scope.endBusinessHours = new Date(0, 0, 0, 0, 0);
                }                                                                                 
              }, function (err) {

                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = `<p>${err.statusText}</p>`;
                    $scope.errTitle = 'Client Settings Error';
                  },],
                });
              })
              .finally(function () {
                progress.complete();
              });
          } else if (valid.agencyValid) {
           // toastFactory.toast_info('Please select a client.');
          } else {
           // toastFactory.toast_info('Please select an agency and then client.');
          }
        };

        $scope.updateOrganization = function () {          
          console.log($scope.agency);          
                    
          progress.start();
          if ($scope.startBusinessHours) {
            const startHour = $scope.startBusinessHours.getHours();
            const startMin = $scope.startBusinessHours.getMinutes();
            $scope.agency.TravelAgencyStartRegularHours = startHour + ':' + startMin;
          } else {
            $scope.agency.TravelAgencyStartRegularHours = '0:0';                    
          }

          if ($scope.endBusinessHours) {
            const endHour = $scope.endBusinessHours.getHours();
            const endMin = $scope.endBusinessHours.getMinutes();          
            $scope.agency.TravelAgencyEndRegularHours = endHour + ':' + endMin;
          } else {
            $scope.agency.TravelAgencyEndRegularHours = '0:0';
          }          

          console.log($scope.agency.TravelAgencyStartRegularHours);
          console.log($scope.agency.TravelAgencyEndRegularHours);

          clientSettings.updateOrganization($scope.agency.Id, $scope.agency).then(function (clientSetting) {
            ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Client Settings Success';
                $scope.successMsg = 'The client settings has been saved succesfully.';
              },],
            });
          })
          .finally(function () {
            progress.complete();
          });
        };

        getOrganizationById();

        // Watch orgFilterService for changes to getFilteredOrganization() output
        // expensive, calls getFilteredOrganization many times during $digest cycle
        $scope.$watch(function () {
          return clientSelectService.getSelectedClient();
        }, function (newValue, oldValue) {

          if (newValue !== oldValue) {
            getOrganizationById();
          }
        }, true);
      },
    ]);
})(angular.module('obex'));



// WEBPACK FOOTER //
// ./client/js/controllers/clientSettingController.js